import * as d3 from 'd3'
export default {
  methods: {

    chart_Controller() {      

      let data = this.chartData
      let actData = this.chartData.filter(f=> f.CDATE <= this.timeline.cutoff)
      let fcData = this.chartData.filter(f=> f.CDATE >= this.timeline.cutoff)

      // Bar Chart 
      this.chart.columns.filter(f=> f.type == 'BAR').forEach((st,i)=> {
        if(st.act == 'Y') data = actData
        if(st.act == 'F') data = fcData
        this.draw_BarChart(data, st, i) // -----> below
      })

      // Line Chart 
      data = this.chartData
      this.chart.columns.filter(f=> f.type == 'LINE').forEach((st,i)=> {
        if(st.act == 'Y') data = actData
        if(st.act == 'F') data = fcData

        this.draw_LineChart(data, st, i)
        if(this.summary.visible == 'Y' && st.act == 'Y') this.draw_Summary(data, st, i) // -----> below
      })
    },


    draw_BarChart(chtData, st, sn) {
      
      chtData.forEach((d,i)=> {
        let value = (d[st.code] < 0) ? 0 : d[st.code]
        let y_ = this.chart.height-this.secondary.axis(value)

        if(this.current.reflash == null) {
          this.canvasChart
          .append('rect')
          .attr('id', `BAR_RECT_${sn}_${i}`)
          .attr('x', d.bxs[sn]).attr('y', y_)
          .attr('width', st.size).attr('height', this.secondary.axis(value))
          .attr('fill', st.color).attr('opacity', st.opacity)

          if(st.vSize > 0) {
            this.canvasChart
            .append('text')
            .attr('id', `BAR_VLAUE_${sn}_${i}`)
            .attr('x', d.bxs[sn] + (st.size/2)).attr('y', y_ -2)
            .attr('font-size', st.vSize).attr('fill',  st.vColor)
            .attr('text-anchor', 'middle')
            .text(value)
          }
        } else if(this.current.reflash == 'Transiton') {
          d3.select(`#BAR_RECT_${sn}_${i}`).transition().duration(400)
          .attr('y', y_).attr('height', this.secondary.axis(value))

          this.gmx_textTween(`#BAR_VLAUE_${sn}_${i}`, value, 400, null, null, y_-2, null)
        }
      })
    },


    draw_LineChart(_data, st, sn) {
      
      let lineFunc = d3.line()
      .x(d => d.mx)
      .y(d => this.primary.axis(d[st.code]))

      this.canvasChart
      .append('path')
      .attr('id', `LINE_CHART_${sn}`)
      .attr('d', lineFunc(_data))
      .attr('stroke', st.color).attr('stroke-width', st.size)
      .attr('fill', 'none').attr('opacity', st.opacity).style("stroke-dasharray", (st.ltype, st.ltype))

      _data.forEach((d,i)=> {
        // Node
        if(st.node > 0 && i > 0) {
          this.canvasChart
          .append('circle')
          .attr('id', `LINE_NODE_${sn}_${i}`)
          .attr('cx', d.mx).attr('cy', this.primary.axis(d[st.code]))
          .attr('r', st.node).attr('fill', st.color).attr('opacity', st.opacity)
        }
        // Value
        if(st.vSize > 0 && d[st.code] > 0) {
          this.canvasChart
          .append('text')
          .attr('id', `LINE_VALUE_${sn}_${i}`)
          .attr('x', d.mx).attr('y', this.primary.axis(d[st.code]) -4)
          .attr('font-size', st.vSize).attr('fill',  st.vColor).attr('text-anchor', 'middle')
          .text(d[st.code])
        }
      })
      
    },

  }
}